import {importOriginal} from './originalImport.js'
import {getSessionGeneration} from '../../lib/sessionGeneration.js'

// Each original is saved through the existing authenticated, exact-binding path.
// Stop at the first uncertain outcome; retry recovers bytes already saved.
export async function importOriginalVariants({files, label='', importOne=importOriginal, onSaved=async()=>{}, currentSession=getSessionGeneration, ...options}) {
  const session=currentSession()
  if(!files?.length || files.length>10)throw new Error('Choose between one and ten original files.')
  const saved=[]
  for(const file of files){
    const name=label.trim()?`${label.trim()} - ${file.name}`:file.name
    if(name.length>140)throw new Error('Version label and filename must total 140 characters or fewer.')
  }
  for(const file of files){
    const name=label.trim()?`${label.trim()} - ${file.name}`:file.name
    const original=name===file.name?file:new File([file],name,{type:file.type,lastModified:file.lastModified})
    try{
      if(currentSession()!==session)throw new Error('Session changed; remaining originals were not imported.')
      const result=await importOne({...options,currentSession,file:original})
      saved.push({name,recovered:result.recovered,job:result.job})
      await onSaved(result)
    }catch(error){return {saved,failed:{name,error:error.message},remaining:files.length-saved.length}}
  }
  return {saved,failed:null,remaining:0}
}
